import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface DealData {
  isDealStructureChanged: boolean;
  assetId?: string;
}

interface IDealAction {
  dealId: string;
  data: DealData;
}

interface IdealInitialState {
  [dealId: string]: DealData;
}

const initialState: IdealInitialState = {};

export const dealSlice = createSlice({
  name: 'deal',
  initialState,
  reducers: {
    setIsDealStructureChanged: (state, action: PayloadAction<IDealAction>) => {
      const { dealId, data } = action.payload;
      state[dealId] = data;
    },
  },
});

export const { setIsDealStructureChanged } = dealSlice.actions;

export const selectIsDealStructureChanged = (dealId: string) => (state: RootState) => state.isDealStructureChanged[dealId];

